import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=0ec0d240&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec0d240')) {
      api.createRecord('0ec0d240', component.options)
    } else {
      api.reload('0ec0d240', component.options)
    }
    module.hot.accept("./IconPlus.vue?vue&type=template&id=0ec0d240&", function () {
      api.rerender('0ec0d240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPlus.vue"
export default component.exports